/**
 * Core data update: PUT _data/{portfolio}/{org}/{ring}/{id}.
 * Uses portfolio/org from config. Send only fields to update (partial). Backend refreshes S3 cache after PUT.
 */

import { getAuthHeaders, buildDataDocUrl } from './request';

export interface PutRingResponse {
  success: boolean;
  message?: string;
  path?: string;
  error?: string;
}

/**
 * Updates an existing document in a ring. Payload is partial (only fields to update).
 */
export async function putRingDoc(
  ring: string,
  id: string,
  payload: Record<string, unknown>
): Promise<PutRingResponse> {
  const url = buildDataDocUrl(ring, id);
  const headers = await getAuthHeaders();
  const res = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(payload),
  });
  const data = (await res.json().catch(() => ({}))) as PutRingResponse;
  if (!res.ok) {
    throw new Error(
      (data?.error as string) || (data?.message as string) || `HTTP ${res.status}`
    );
  }
  return data;
}
